import CircularProgress from '@mui/material/CircularProgress';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

import { useMst } from '../../models/rootModel';
import { UserDiscoveryResponse } from '../../models/UserDiscoveryResponse';
import { useAnalytics } from '../../utils/analytics';

import { AnswersFunnelButton } from '../common/AnswersFunnelButton';
import { AnalyticsDataProps, BaseStep, StepProps, StepWizardProps, TitleAndDescriptionProps } from '../common/BaseStep';
import { LoaderDiv, StepWrapperBox } from '../styledComponent/Boxes.style';

interface CriteriaStepProps extends TitleAndDescriptionProps, StepWizardProps, StepProps, AnalyticsDataProps {
  criteriaType: string;
  isDiscoveryFinished?: boolean;
  responseMapping?: {
    [key: string]: string;
  };
}

export const CriteriaStep = observer((props: CriteriaStepProps) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [answer, setAnswer] = useState<UserDiscoveryResponse>();
  const { criteriaType, nextStep, isDiscoveryFinished, responseMapping, goToNamedStep, isActive } = props;
  const { Criteria, UserDiscoveryResponse, Step } = useMst();
  const analytics = useAnalytics();

  useEffect(() => {
    if (isActive) {
      setAnswer({
        type: '',
        name: '',
        meta: null,
      });

      return window.scrollTo(0, 0);
    }
  }, [isActive]);

  const clickedAnswer = ({ type, name }: UserDiscoveryResponse) => {
    setAnswer({ type, name, meta: null });
    setIsButtonDisabled(false);
    analytics.track(`criteria set ${criteriaType}`, {
      selectedValue: name,
      stepId: props.id,
      stepType: props.type,
      stepIndex: props.stepIndex,
      stepTitle: props.title,
      ...props?.analytics,
      ...UserDiscoveryResponse.utms,
      origin: Step.origin,
      userID: UserDiscoveryResponse.accountId,
    });
  };

  const getNextStep = () => {
    const nextStepId = (responseMapping && answer && responseMapping[answer.name]) || null;
    !nextStepId ? nextStep() : goToNamedStep(nextStepId);
  };

  const changeButtonFunction = () => {
    UserDiscoveryResponse.addUserAnswers(answer as UserDiscoveryResponse);

    const discoveryObj = {
      discovery: {
        byOrigin: true,
        origin: Step.origin,
        ...UserDiscoveryResponse.userAnswersObject,
      },
      ...UserDiscoveryResponse.userBirthDayAndGender,
    };

    if (Step.isReDiscovery && props.totalSteps === props.stepIndex + 1) {
      // add the date of birth and gender to rediscovery
      UserDiscoveryResponse.userReDiscovery(discoveryObj);
    }

    if (isDiscoveryFinished) {
      if (Step.isReDiscovery) {
        // add the date of birth and gender to rediscovery
        UserDiscoveryResponse.userReDiscovery(discoveryObj);
        return;
      }
      UserDiscoveryResponse.updateDiscoveryDone(discoveryObj);
    }

    getNextStep();
  };

  return (
    <>
      {isActive && Criteria.criterias.length > 0 ? (
        <BaseStep {...props} isButtonDisabled={isButtonDisabled} changeButtonFunction={changeButtonFunction}>
          <StepWrapperBox>
            {Criteria.getCriteriasByType(criteriaType).map((criteria, index) => {
              return (
                <AnswersFunnelButton
                  criteria={criteria}
                  key={criteria.id}
                  isActive={criteria.id === answer?.name}
                  onClick={clickedAnswer}
                />
              );
            })}
          </StepWrapperBox>
        </BaseStep>
      ) : (
        <LoaderDiv>
          <CircularProgress />
        </LoaderDiv>
      )}
    </>
  );
});
